export const EMAIL = "services@coresmith.dev";

/* Adresa și telefonul din fișa Google Business.
 *
 *  Au stat mult timp nepublicate aici, cu argumentul că un oraș spune
 *  motorului unde ești și o stradă nu adaugă nimic. Argumentul a căzut în
 *  momentul în care fișa a intrat live: sunt publice pe hartă, cu pin. Rămâne
 *  doar dezavantajul de a le avea într-un loc și nu în celălalt — Google
 *  compară fișa cu site-ul, iar ce nu poate corobora nu poate nici confirma.
 *
 *  Forma trebuie să rămână identică între cele trei locuri: aici, în fișă și
 *  în structured data. O stradă scrisă altfel în două locuri e o nepotrivire,
 *  nu o variantă.
 *
 *  Și gruparea cifrelor face parte din formă. Numărul național moldovenesc are
 *  opt cifre, iar convenția le desparte 69 492 222 — nu 694 92 222, care e
 *  aceeași cifră tăiată greșit. Semnătura de email o avea corect de la
 *  început; site-ul a fost cel care a deviat. */
/* Forma internațională și în pagină, nu doar în marcaj.
 *
 *  Întâi pentru că studioul lucrează în șase țări și „0694" nu se poate forma
 *  din niciuna dintre celelalte cinci. Apoi pentru că un verificator — om sau
 *  crawler — nu poate deduce prefixul de țară dintr-un număr local: crawlview
 *  a raportat exact asta, structured data declarând +373 pe o pagină care
 *  arăta doar forma locală. Aceeași cifră în ambele locuri, fără traducere. */
export const PHONE_DISPLAY = "+373 69 492 222";
export const PHONE_E164 = "+37369492222";
export const ADDRESS = {
  street: "Alba Iulia",
  locality: "Chișinău",
  postalCode: "MD-2071",
  country: "MD",
} as const;

// Configured via VITE_BOOKING_URL at build time. Falls back to mailto so
// the CTA never points at a 404 if someone forgets to set it.
export const BOOKING_URL =
  import.meta.env.VITE_BOOKING_URL || `mailto:${EMAIL}?subject=Strategy%20call`;

/* WhatsApp și Telegram. Configurate la build prin VITE_WHATSAPP_URL și
   VITE_TELEGRAM_URL; când lipsesc, linkurile nu se randează deloc.
   Spre deosebire de BOOKING_URL, aici nu există o rezervă rezonabilă: un
   „scrie-mi pe WhatsApp" care deschide un mailto e o minciună mică. */
export const WHATSAPP_URL = import.meta.env.VITE_WHATSAPP_URL || null;
export const TELEGRAM_URL = import.meta.env.VITE_TELEGRAM_URL || null;
